import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions'> {
    onGetSuggestions?: (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de treinamento.
 * @param props
 */
export const AssEvaluationAutoComplete: React.FC<Props> = ({
    label = "",
    onGetSuggestions, onChange, onError, ...props
}) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.assSuggestions.evaluationSuggestions({
                searchText,
                pageNumber,
                pageSize,
            }, { signal })
                .then(result => resolve({
                    items: result.data.items as AutoCompleteDataModel[],
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            label={label}
            onError={onError}
            onGetSuggestions={onGetSuggestions ?? getSuggestions}
            onChange={onChange}
        />
    );
};
